// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import { RichText } from 'prismic-dom'
import VueScrollTo from 'vue-scrollto'

Vue.use(VueScrollTo)

Vue.config.productionTip = false
Vue.config.PrismicAPI = process.env.PRISMIC
Vue.config.IMG = {
  baseUrl: process.env.CLOUDINARY,
  sizes: [320, 480, 640, 800, 1024, 1280, 1440, 1600, 1920, 2048, 2560]
}

// update Meta
Vue.updateMeta = {
  _siteTitle: 'Daniel Benson',
  _siteDescription: 'Photographer based in London',
  setTitle (pageTitle = '') {
    const title = pageTitle.length > 0 ? pageTitle + ' | ' + this._siteTitle : this._siteTitle
    document.title = title
  },
  setDescription (descrip = '') {
    descrip = descrip.length > 0 ? descrip : this._siteDescription
    const set = (el, txt) => el ? el.setAttribute('content', txt) : false
    const meta = document.querySelector('meta[name="description"]')
    const ogMeta = document.querySelector('meta[property="og:description"]')
    set(meta, descrip)
    set(ogMeta, descrip)
  },
  set (title, descrip) {
    this.setTitle(title)
    this.setDescription(descrip)
  }
}

// Cloudinary thumb fetching
Vue.thumbSrc = (src, length, useHeight = false, format = 'jpg') => {
  // return `${Vue.config.IMG.url}/image/fetch/${src}`
  let optimal = 0
  const dpx = window.devicePixelRatio * 0.8 // less density optically ok ?
  length = length * dpx
  const sizes = Vue.config.IMG.sizes
  for (var i = 0; i < sizes.length; i++) {
    if (length <= sizes[i]) {
      optimal = sizes[i]
      break
    }
  }
  const size = optimal === 0 ? sizes[sizes.length - 1] : optimal
  const urlParam = useHeight ? 'h_' + size : 'w_' + size
  return `${Vue.config.IMG.baseUrl}/image/fetch/q_auto:best,${urlParam},f_${format}/${src}`
}

// Prismic raw Text
Vue.filter('text', function (field) {
  if (!field || !field[0]) return ''
  return field[0].text
})

// Prismic Rich Text
Vue.filter('richtext', function (key) {
  if (!key) return ''
  const html = RichText.asHtml(key, () => '/') // all internal links go to '/'
  return html
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js